interface Props {
  text: string
}
export const Copyright: React.FC<Props> = ({ text }) => {
  return (
    <div className="p-5 my-10 text-sm bg-[#f6f9fb]">
      <div>{text}</div>
    </div>
  )
}
